import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PlatformMode } from './models/platform-mode.model';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Flex Privacy Policy', data: { mode: PlatformMode.WEB } },
  { path: 'privacy-policy', component: HomeComponent, title: 'Flex Privacy Policy', data: { mode: PlatformMode.WEB } },
  { path: 'mobile/privacy-policy', component: HomeComponent, title: 'Flex Privacy Policy', data: { mode: PlatformMode.APP } },
];
